import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import ReactDataTable from "../../Components/ReactDataTable";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import {
  getbulletinDraftDetailAction,
  draftBulletinActiveStatus,
  CLEAR_BULLETIN_SUCCESS,
  publishedBulletinStatus,
} from "../../Redux/Actions/BulletinAction";
import ReactLoading from "react-loading";

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import {
  Box,
  List,
  Stack,
  Button,
  ButtonGroup,
  Typography,
  Checkbox,
} from "@mui/material";
import {
  searchBulletin,
  RemoveBulletin,
} from "../../Redux/Actions/BulletinAction";
import CreateBulletin from "./CreateBulletin";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ResponsiveDialog from "../../Components/DialogBox";
import {
  CLEAR_EXPLORE_DATA,
  CopyContent,
} from "../../Redux/Actions/ExploreAction";

export const Bulletin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, bulletinList, totalCount } = useSelector(
    (state) => state.Bulletin
  );
  const { copy_status } = useSelector((state) => state.Explore);
  const [selectedTab, setSelectedTab] = useState("PUBLISHED");
  const [tabNavigate, setTabNavigate] = useState("");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(false);
  const { setMsgConfig } = useErrorHandler();
  const location = useLocation();
  const [loaderTimeOut, setLoaderTimeOut] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [itemId, setItemId] = useState();
  const [model, setModel] = useState("Delete");
  const [details, setDetails] = useState({ id: "", is_publish: false });

  let data;
  if (bulletinList?.length) {
    if (selectedTab === "PUBLISHED") {
      data = bulletinList?.map((e) => e);
    } else if (selectedTab === "SANDBOX") {
      data = bulletinList?.map((e) => e);
    }
  }
  const [navigateUrl, setNavigateUrl] = useState("/programs");

  useEffect(() => {
    location?.state === "DRAFTS"
      ? setTabNavigate("DRAFTS")
      : setTabNavigate("PUBLISHED");
  }, [location?.state, tabNavigate]);

  useEffect(() => {
    if (tabNavigate) {
      setSelectedTab(tabNavigate);
    }
  }, [tabNavigate]);
  useEffect(() => {
    dispatch({ type: CLEAR_EXPLORE_DATA });
    if (copy_status) {
      setSelectedTab("SANDBOX");
    }
  }, [copy_status]);
  useEffect(() => {
    if (selectedTab === "PUBLISHED") {
      setNavigateUrl(`/bulletin/published`);
    } else if (selectedTab === "SANDBOX") {
      setNavigateUrl(`/bulletin/SANDBOX`);
    }
    onTableChange();
  }, [selectedTab]);

  const onTableChange = (filter) => {
    if (selectedTab === "PUBLISHED") {
      const searchPayload = {
        type: "publish",
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "Id",
        sortDirection: filter?.direction || "DESC",
      };
      dispatch(searchBulletin(searchPayload));
    } else if (selectedTab === "SANDBOX") {
      const searchPayload = {
        type: "sandbox",
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "Id",
        sortDirection: filter?.direction || "DESC",
      };
      dispatch(searchBulletin(searchPayload));
    }
  };

  useEffect(() => {
    onTableChange();
  }, [selectedTab, filterText, copy_status]);
  const handleAllow = () => {
    setIsVisibleModal(false);
    setModel("Delete");
    handlechecked(true);
    //write code for notification allow
  };

  const handlechecked = (notify) => {
    const payload = {
      Id: details.id,
      is_publish: details.is_publish,
      is_notify: notify,
    };
    dispatch(publishedBulletinStatus(payload));
    setMsgConfig({
      alertOpen: true,
      message: "Something went wrong!!",
      severity: "error",
      autoHideDuration: 2000,
    });
  };

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search by title"
      />
    );
  }, [filterText, resetPaginationToggle]);

  const goToDetailScreen = (id) => {
    setOpenEditForm(true);
    dispatch(getbulletinDraftDetailAction(id.Id));
    navigate(`/bulletin/create`);
  };

  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };

    dispatch(RemoveBulletin(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Program SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.Id);
  };

  const handleStatusChange = (item, value) => {
    if (value === "Delete") {
      setIsVisibleModal(true);
      setItemId(item?.Id);
    } else {
      const payload = {
        Id: item?.Id,
        is_active: value,
      };
      dispatch(draftBulletinActiveStatus(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Bulletin Status Update SuccessFully!!",
        severity: "success",
        autoHideDuration: 2000,
      });
    }
  };

  const columns = [
    {
      name: "DUPLICATE",
      center: true,
      omit: selectedTab !== "DRAFTS" ? false : true,
      cell: (row) => {
        return (
          <Box sx={{ cursor: "pointer" }}>
            <ContentCopyOutlinedIcon
              onClick={() => {
                if (row) {
                  const payload = {
                    content_id: row.Id,
                    type: "bulletin",
                  };
                  dispatch(CopyContent(payload));
                }
                //Called api for copied program data
              }}
            />
          </Box>
        );
      },
    },
    {
      name: "TITLE",
      sortField: "title",
      sortable: true,
      selector: (row) => row.title,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.title}</span>
          </span>
        );
      },
    },

    {
      name: "CONTRIBUTOR NAME",
      sortField: "contributor_name",
      sortable: true,
      selector: (row) => row.contributor_name,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.contributor_name}</span>
          </span>
        );
      },
    },

    {
      name: "DATE CREATED",
      sortField: "created_at",
      selector: (row) => row.created_at,
      sortable: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.created_at
                ? moment(row.created_at).format("DD/MM/YYYY")
                : "N/A"}{" "}
            </span>
          </span>
        );
      },
    },
    {
      name: "STATUS",
      sortField: "is_publish",
      selector: (row) => row.is_publish,
      width: "250px",
      center: true,
      style: { width: "100px", "margin-left": "20px" },
      cell: (row) => {
        return (
          <div className="badge bg-light-danger">
            <Typography>Published</Typography>
            <br />
            <Checkbox
              checked={row.is_publish}
              onChange={(e) => {
                setDetails({
                  id: row.Id,
                  is_publish: e.target.checked,
                });
                if (row.is_publish) {
                  dispatch(
                    publishedBulletinStatus({
                      Id: row.Id,
                      is_publish: e.target.checked,
                    })
                  );
                  setMsgConfig({
                    alertOpen: true,
                    message: "Success!!",
                    severity: "success",
                    autoHideDuration: 2000,
                  });
                } else {
                  setModel("Published");
                  setIsVisibleModal(true);
                }
              }}
            />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "BULLETIN STATUS",
      sortField: "is_active",
      selector: (row) => row.is_active,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <span className="badge bg-light-danger">
                <span className="status">
                  {row.is_active ? "Active" : "Inactive"}
                </span>
              </span>
              <span className="status-icon-btn view-detail-btn">
                <ActionButton
                  isUpdateIcon={true}
                  handleStatusChange={handleStatusChange}
                  item={row}
                  isEditMode={true}
                />
              </span>
            </Box>
          </>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      omit: selectedTab === "SANDBOX" ? false : true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        return (
          <>
            {selectedTab !== "PUBLISHED" ? (
              <span className="edit-icon-btn view-detail-btn">
                <ActionButton
                  isEditIcon={true}
                  goToDetailScreen={goToDetailScreen}
                  item={row}
                  isEditMode={true}
                />
              </span>
            ) : (
              ""
            )}
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row}
                isEditMode={true}
              />
            </span>
          </>
        );
      },
    },
  ];

  return (
    <>
      <ResponsiveDialog
        dtype={model === "Published" ? "permission" : "confirm"}
        open={isVisibleModal}
        header={
          model === "Published"
            ? "Do you want to notify users of publishing?"
            : "Are you sure you want to delete this program?"
        }
        onConfirm={() =>
          model === "Published" ? handleAllow() : handleConfirm()
        }
        onClose={() => {
          if (model === "Published") {
            setModel("Delete");
            handlechecked(false);
          }
          setIsVisibleModal(false);
        }}
      ></ResponsiveDialog>
      <HelmetReact name="Bulletin" />
      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          <Button
            className={`${selectedTab === "PUBLISHED" ? "active" : ""}`}
            onClick={() => {
              setLoaderTimeOut(true);
              setTimeout(() => {
                setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("PUBLISHED");
              setFilterText("");
            }}
          >
            PUBLISHED
          </Button>

          <Button
            className={`${selectedTab === "SANDBOX" ? "active" : ""}`}
            onClick={() => {
              setLoaderTimeOut(true);
              setTimeout(() => {
                setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("SANDBOX");
              setFilterText("");
            }}
          >
            SANDBOX
          </Button>
        </ButtonGroup>
        <List component={Stack} direction="row"></List>

        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
            }}
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              setOpenEditForm(false);
              dispatch({ type: CLEAR_BULLETIN_SUCCESS });
              navigate("/bulletin/create");
            }}
          >
            CREATE BULLETIN
          </Button>
        </Box>
        {loaderTimeOut ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 15,
            }}
          >
            <ReactLoading
              type="cylon"
              height="80px"
              width="80px"
              color="#39a2e8"
            />
          </Box>
        ) : (
          <ReactDataTable
            columns={columns}
            items={data}
            onChange={onTableChange}
            totalRows={totalCount}
            isLoading={loading}
            navigateUrl={navigateUrl}
            isShowSearch={true}
            paginationResetDefaultPage={resetPaginationToggle}
            subHeader
            pagination
            subHeaderComponent={subHeaderComponentMemo}
          />
        )}
      </Box>
      {openEditForm && (
        <CreateBulletin
          setOpenEditForm={setOpenEditForm}
          openEditForm={openEditForm}
        />
      )}
    </>
  );
};
